<latch-active-sessions (cancel)="onCancelClick()"
  (logOutCompleted)="handleLogOutCompleted()">
</latch-active-sessions>
